import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
export const Content = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "flex size-full",
        children: /*#__PURE__*/ _jsx("div", {
            className: "flex min-h-full w-full flex-col items-start justify-start rounded-lg bg-grey-1 transition-colors",
            children: children
        })
    });
});
Content.displayName = "Content";
